import { showToastMessage } from '@/utils';

export const handleApiError = (err: any, fallbackMsg = 'Something went wrong') => {
  console.log('API Error:', err);

  const message = err?.data?.message || err?.error || err?.message || fallbackMsg;

  showToastMessage('error', message);
};
